/*
 *  Extend the SDK utilities library
 */

function ExtendUtilities () {
if (typeof STRY !== 'undefined' && typeof STRY.util === 'object') {


    /**
     * Function used to extract data attributes and values from component instances.
     * @memberof ExtendUtilities
     * @function extractInstanceAttributes
     * @param {object} elem - Component element.
     * @param {string} attribute_name - String name of the data attribute of the component.
     * @inner
     */
    STRY.util.extractInstanceAttributes = function (elem, attribute_name) {
        var attrs;
        var item;
        var property_name;
        var property;
        var string_to_match = attribute_name + '-';
        var value;
        var results = {};

        //  Check all the attributes on the element
        for (item in elem.attributes) {

            //  Shorthand attributes object
            attrs = elem.attributes[item];

            //  Only analyse if a string based name can be found
            //  and, if it contains the component attribute name followed by a hyphen (which means it has a property name)
            if (attrs.name && attrs.name.indexOf(string_to_match) > -1) {

                //  Strip the attribute name prefix (this is mainly for brevity)
                property = attrs.name.replace(string_to_match, '');

                //  Define value
                value = attrs.value;

                //  Check if the value is actually a number and convert
                if (typeof value === 'string' && (/^\d+$/).test(value)) {
                    value = parseFloat(value);
                }

                //  Format the property correctly
                property_name = STRY.util.formatPropertyName(property, 'stry');

                //  Add to results
                results[property_name] = value;
            }
        }

        return results;
    };


    /**
     * Function used to convert strings into valid property names.
     * @memberof ExtendUtilities
     * @function formatPropertyName
     * @param {string} str - The string to be converted.
     * @param {string} prefix - Option string to be appended to the star of the property name (used to avoid conflicts on objects).
     * @inner
     */
    STRY.util.formatPropertyName = function (str, prefix) {
        var formatted = '';
        var index;
        var len;
        var wip_str;

        //  Add prefx namespace if provided
        if (typeof prefix === 'string') {
            formatted = prefix;
        }

        //  Normalise string
        str = str.toLowerCase();

        //  Split string where hyphens are found
        wip_str = str.split('-');

        //  Do this if hyphens are found in the string
        if (wip_str.length > 1) {
            index = 0;
            len = wip_str.length;

            //  Set first character to uppercase and every word found following a hyphen
            while (len--) {
                formatted += wip_str[index].charAt(0).toUpperCase() + wip_str[index].slice(1);
                index += 1;
            }
        }

        //  No hyphens
        else {

            //  Set first character to uppercase.
            formatted += str.charAt(0).toUpperCase() + str.slice(1);
        }


        return formatted;
    };



    STRY.util.repaint = {};


    STRY.util.repaint.run = function (callback, param1) {
        var frame_id;
        frame_id = window.requestAnimationFrame(function() {
            callback(param1);
        });

        return frame_id;
    };


    STRY.util.repaint.cancel = function (id) {

        window.cancelAnimationFrame(id);
    };

}}
